export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: any;
  LocalDate: any;
  LocalDateTime: any;
  Long: any;
  Map_String_ObjectScalar: any;
  ObjectScalar: any;
  Short: any;
  UNREPRESENTABLE: any;
};

export type Maybe<T> = T | null;

export type InputMaybe<T> = Maybe<T>;

export enum OrderDirectionEnum {
  Asc = "ASC",
  Desc = "DESC"
}

export type OrderEntryInput = {
  direction?: InputMaybe<OrderDirectionEnum>;
  path?: InputMaybe<Scalars["String"]>;
};

export type FilterEntryInput = {
  operator?: InputMaybe<FilterOperatorEnum>;
  path?: InputMaybe<Scalars["String"]>;
  value?: InputMaybe<Scalars["ObjectScalar"]>;
};

export type FilterExpressionChildInput = {
  entry?: InputMaybe<FilterEntryInput>;
  expr?: InputMaybe<FilterExpressionInput>;
};

export type FilterExpressionInput = {
  children?: InputMaybe<Array<InputMaybe<FilterExpressionChildInput>>>;
  operator?: InputMaybe<FilterExpressionOperatorEnum>;
};

export enum FilterExpressionOperatorEnum {
  And = "AND",
  Not = "NOT",
  Or = "OR"
}

export enum FilterOperatorEnum {
  Contains = "CONTAINS",
  Empty = "EMPTY",
  EndsWith = "ENDS_WITH",
  Equal = "EQUAL",
  GreaterEqual = "GREATER_EQUAL",
  GreaterThan = "GREATER_THAN",
  In = "IN",
  Like = "LIKE",
  LowerEqual = "LOWER_EQUAL",
  LowerThan = "LOWER_THAN",
  NotEmpty = "NOT_EMPTY",
  NotEqual = "NOT_EQUAL",
  NotIn = "NOT_IN",
  NotNull = "NOT_NULL",
  Null = "NULL",
  StartsWith = "STARTS_WITH"
}
